module.exports = __webpack_public_path__ + "static/media/greylock.acb58e63.png";